import { getEnvironment as u, CONSTs as c, parseQuery as g } from "./utils/common-utils.js";
const d = {
  TYPE_ANALYTICS_CUSTOM_EVENT: "triggerAnalytics"
}, h = {
  NAV: "nav",
  NAV_TRAY: "navtray",
  BREADCRUMB: "breadcrumb"
};
class l {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
  }
  setSatelliteTrack(e = "", n = "") {
    return window._satellite && typeof window._satellite.track == "function" && e && n && window._satellite.track(e, n), !0;
  }
  ping(e, n, s, t = "link") {
    let i = t;
    if (!e || typeof e != "string" || e.length < 1) {
      console.warn("analytics.ping() received an invalid message. message must be a string.");
      return;
    }
    if (!n || typeof n != "string" || n.length < 1) {
      console.warn("analytics.ping() received an invalid href. href must be a string.");
      return;
    }
    if ((!s || typeof s != "string" || s.length < 1) && console.warn("analytics.ping() received no siteId."), !t || typeof t != "string" || t.length < 1) {
      console.warn(
        "analytics.ping() received an invalid Ping Source Type. Ping Source Type must be a string."
      );
      return;
    }
    i = i.toLowerCase(), this.pingCustomEvent(e, n, s, i, d.TYPE_ANALYTICS_CUSTOM_EVENT);
  }
  pingCustomEvent(e, n, s, t, i) {
    let r;
    const o = { detail: {} };
    o.detail = { message: e, href: n, siteId: s, type: t };
    try {
      r = new CustomEvent(i, o);
    } catch {
      r = document.createEvent("CustomEvent"), r.initCustomEvent(i, !1, !1, o);
    }
    document.body.dispatchEvent(r);
  }
}
const m = (a) => {
  var e;
  return !((e = a.HstMenuItemRepresentation.menuItems) != null && e.length) || a.HstMenuItemRepresentation.parameters.showDropdown !== "true" ? 0 : a.HstMenuItemRepresentation.menuItems.length + a.HstMenuItemRepresentation.menuItems.reduce((n, s) => n + m(s), 0);
}, w = (a) => {
  const e = window.location.href, n = u();
  let s = "";
  if (e && n !== c.UNKNOWN && n !== c.PREVIEW) {
    const t = e.split("/");
    if (t != null && t.length && t.length > 1) {
      const i = t[n !== c.LOCAL ? 2 : 4];
      i && i.length > 1 && a.forEach((r) => {
        e.includes(r.HstMenuItemRepresentation.url) && (s = r.HstMenuItemRepresentation.name);
      });
    }
  }
  return s;
}, E = (a, e, n, s) => {
  if (!n)
    return;
  const { href: t } = a.target;
  let i = "";
  if (t && t !== null && t.indexOf("&siteid") > -1 && (i = g(t).siteid.split("#")[0]), s)
    try {
      new l().setSatelliteTrack(s, t);
    } catch (r) {
      console.error(r);
    }
  try {
    new l().ping(n, t, i, e);
  } catch {
  }
};
export {
  h as A,
  m as a,
  w as g,
  E as h
};
//# sourceMappingURL=common-utils-Bb7wjgT2.mjs.map
